import { api } from '@/core/helpers/axiosHelper';
import { LocationQuery } from 'vue-router';
import { Batch } from './batch.interface';

export class BatchService {
   async getBatch(batchId: number) {
      const response = await api.get<Batch>(`/batches/${batchId}`);
      return response.data;
   }
   async getBatches(query?: LocationQuery) {
      const response = await api.get(`/batches`, { params: { ...query } });
      return response.data;
   }
}
